import { render, staticRenderFns } from "./KBUB.vue?vue&type=template&id=24956257&"
import script from "./KBUB.vue?vue&type=script&lang=js&"
export * from "./KBUB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports